export const GET_HOME_DATA_API =  'GET_HOME_DATA_API';
